import StoryPanel from "./StoryPanel";
import Pumpkins from "../Utils/Pumpkins";
import {CONFIG} from "../config";

export default class Conclusion extends StoryPanel{
    constructor(name, model) {
        super(name, model);
    }
    init(resolve, reject) {
        super.init(resolve, reject);
        var Results = this;
        var pumpkins = new Pumpkins(CONFIG.year);
        pumpkins.get().then((values) => {
            var key = localStorage.getItem("vote"+CONFIG.year);
            var selection = values[values.findIndex((val)=>{
                return val.key === key;
            })];
            document.getElementById("PumpkinImage").setAttribute("xlink:href", selection.Image)
        });
    }
}


// WEBPACK FOOTER //
// ./src/views/Conclusion.js